import { render, staticRenderFns } from "./MaxInteractionCard.vue?vue&type=template&id=0aa55d19&scoped=true"
import script from "./MaxInteractionCard.vue?vue&type=script&lang=ts"
export * from "./MaxInteractionCard.vue?vue&type=script&lang=ts"
import style0 from "./MaxInteractionCard.vue?vue&type=style&index=0&id=0aa55d19&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa55d19",
  null
  
)

export default component.exports